module.exports = __webpack_public_path__ + "img/checklist-pending.cddefd19.svg";